<template>
  <div>
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}{{route.menuName}}</span>
      </div>

      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">基础信息</span>
          </div>
          <el-row>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="no" label="申请单号" v-if="getIsView()">
                <el-input disabled v-model="form.no"></el-input>
              </el-form-item>
              <span class="viewText" v-else>申请单号:{{ form.no }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="supplierName" label="供应商" v-if="getIsView()">
                <el-select v-model="form.supplierName" :disabled="!editMode" placeholder="请选择供应商" filterable :filter-method="getSuppliers" @change="supplierChange" style="width:100%">
                  <el-option key="0" label="请选择供应商" value></el-option>
                  <el-option v-for="item in STATIC_Suppliers" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>供应商:{{ form.supplierName }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="type" label="付款方式" v-if="getIsView()">
                <el-select v-model="form.type" :disabled="!editMode" placeholder="请选择" style="width:100%">
                  <el-option v-for="item in PaymentApplyTypeOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>付款方式:{{ PaymentApplyTypeOptions.find(item => item.id === form.type)?.name  }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="date" label="放款期限" v-if="getIsView()">
                <el-date-picker v-model="form.date" :disabled="!editMode" size="small" type="date" format="yyyy-MM-dd" style="width:100%" value-format="yyyy-MM-dd" placeholder="放款期限"></el-date-picker>
              </el-form-item>
              <span class="viewText" v-else>放款期限:{{ parseTime(new Date(form.data) ,"{y}-{m}-{d}") }} </span>
            </el-col>

            <!-- <el-col :span="6">
              <el-form-item prop="ownerDeptName" label="所属科室">
                <el-input disabled v-model="form.ownerDeptName"></el-input>
              </el-form-item>
            </el-col> -->
          </el-row>

          <el-row>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="createdUserName" label="申请人" v-if="getIsView()">
                <el-input disabled v-model="form.createdUserName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>申请人:{{ form.createdUserName }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item label="申请时间" prop="createdTime" v-if="getIsView()">
                <el-date-picker v-model="form.createdTime" disabled type="datetime" placeholder="系统自动带出创建时间" style="width: 100%">
                </el-date-picker>
              </el-form-item>
              <span class="viewText" v-else>申请时间:{{ parseTime(new Date(form.createdTime) ,"{y}-{m}-{d} {h}:{i}:{s}") }} </span>
            </el-col>

            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="totalAmount" label="请款金额(元)" v-if="getIsView()">
                <el-input disabled v-model="form.totalAmount"></el-input>
              </el-form-item>
              <span class="viewText" v-else>请款金额(元):{{ form.totalAmount }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="stateName" label="状态" v-if="getIsView()">
                <el-input disabled v-model="form.stateName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>状态:{{ form.stateName }} </span>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="remark" label="付款内容" v-if="getIsView()">
                <el-input :disabled="!editMode" v-model="form.remark"></el-input>
              </el-form-item>
              <span class="viewText" v-else>付款内容:{{ form.remark }} </span>
            </el-col>
          </el-row>
          <el-row style="margin-top: 20px"></el-row>
        </div>

        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">发票明细</span>
          </div>

          <div v-if="editMode" style="margin: 20px 0 12px 10px">
            <el-button class="btn default" size="small" v-preventReClick @click="handleAddChildForm">新增明细</el-button>
            <el-button class="btn" size="small" type="danger" :disabled="childMultiple" v-preventReClick @click="handleDeleteChildForm">删除</el-button>
          </div>
          <div v-else style="margin-top: 20px"></div>

          <el-table ref="childTable" border :data="form.details" style="width: auto; margin: 0 10px" @selection-change="handleChildSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
            <el-table-column type="selection" width="55" align="center" fixed></el-table-column>
            <el-table-column type="index" width="50"> </el-table-column>
            <el-table-column prop="invoiceRegisterNo" label="发票登记单号">

            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="billNo" label="发票号码">
              <template slot-scope="scope">
                <span v-if="editMode">
                  {{scope.row.billNo}}
                </span>
                <span v-else class="pointer color-blue" @click="toInvoiceRegister(scope.row)">{{scope.row.billNo}}</span>
              </template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="date" label="发票日期">
              <template slot-scope="scope">
                {{scope.row.date ? parseTime(new Date(scope.row.date), "{y}-{m}-{d}") : ''}}
              </template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="remark" label="摘要" />
            <el-table-column prop="totalAmount" label="发票金额" width="120">
            </el-table-column>
            <el-table-column prop="unReceivedAmount" label="剩余未付金额" width="120">
            </el-table-column>
            <el-table-column prop="thisPayAmount" label="本次付款金额" width="120">
              <template slot-scope="scope">
                <el-input :disabled="!editMode" placeholder="请输入本次付款" type="number" min="0" @input='amountChange(scope.row)' v-model="scope.row.thisPayAmount"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>

    </div>
    <div slot="footer" class="footer-bottom">
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">提交审批</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="goBack">返 回</el-button>
    </div>
    <SelectDialog ref="selectDialog" :show="showSelectDialog" :dialogTitle="selectDialogTitle" @close="closeSelectDialog" @returnData="getSelectDialogData" :filterOptions="filterOptions" :columOptions="columnOptions" :getDataFunction="GetInvoiceRegisters"></SelectDialog>
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import {
  GetPaymentApplyById,
  SavePaymentApply,
  RejectPaymentApply,
  GetInvoiceRegisters
} from "@/api";
import { PaymentApplyTypeOptions } from "@/enum";
import ApproveInfo from "@/components/approve-info";
import SelectDialog from "@/components/select-dialog";

export default {
  name: "paymentApplyEdit",
  mixins: [GetDataMixin, GetDataSpdMixin],
  components: {
    ApproveInfo,
    SelectDialog
  },
  data () {
    return {
      GetDataAction: GetPaymentApplyById,
      SaveDataAction: SavePaymentApply,
      reject: RejectPaymentApply,
      form: {},

      GetInvoiceRegisters: GetInvoiceRegisters,

      PaymentApplyTypeOptions: PaymentApplyTypeOptions,
      rules: {
        supplierName: [
          { required: true, message: '请选择供应商', trigger: 'blur' }
        ],
      },

      // 子表
      childIds: [],
      childMultipleSelection: [],
      childMultiple: true,
      childForm: {},

      editMode: false,
      showWorkFlowInfo: false,

      billRegisterList: [],

      showSelectDialog: false,
      selectDialogTitle: '选择待付款发票',
      filterOptions: [
        {
          name: "发票登记流水号",
          type: "input",
          code: "keyWord",
        },
        {
          name: "发票号码",
          type: "input",
          code: "billNo",
        },
        {
          name: "日期范围",
          type: "date",
          code: "date",
        },
        {
          name: "状态",
          type: 'select',
          code: 'states',
          multiple: true,
          hidden: true,
          defaultValue: [1, 2]
        }
      ],
      columnOptions: [
        {
          label: "发票登记流水号",
          key: "no",
        },
        {
          label: '发票号码',
          key: 'billNo'
        },
        {
          label: "发票日期",
          key: "date",
          type: 'date'
        },
        {
          label: "摘要",
          key: "remark",
        },
        {
          label: "发票金额",
          key: "invoiceAmount",
        },
        {
          label: "剩余未付金额",
          key: "unReceivedAmount",
        },
      ],
      id: ''
    };
  },

  created () {
    var query = this.$route.query;
    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();
    }


    let params = this.$route.params
    if (params) {
      let supplierId = params.supplierId
      let supplierName = params.supplierName
      let registerArray = params.registerArray

      if (supplierId != 0) {
        this.form.supplierId = supplierId
        this.form.supplierName = supplierName
      }
      if (registerArray && registerArray.length > 0) {
        registerArray.map(e => {
          var detail = Object.assign({}, e)
          detail.invoiceRegisterId = e.id
          detail.invoiceRegisterNo = e.no
          // detail.billNo = e.billNo
          // detail.totalAmount = e.totalAmount
          detail.thisPayAmount = e.unReceivedAmount

          this.form.details.push(detail)
        })

        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });

        this.autoTotalAmount()
      }
      if (params.applyId) {
        this.handleUpdate(params.applyId);
      }
    }
    this.getSuppliers('')
  },
  methods: {
    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;
    },
    // 编辑
    handleUpdate (id) {
      this.GetDataAction({ id }).then((res) => {
        this.id = id
        // this.resetForm()
        this.form = res.returnData;
        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });

        this.initWorkFlowProperty(this.form);
      });
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        if (this.form.details) {
          for (let i = 0; i < this.form.details.length; i++) {
            if (!this.form.details[i].thisPayAmount || this.form.details[i].thisPayAmount < 0) {
              this.$my_message(`第${i + 1}行本次付款金额必须大于0`, 'warning')
              return
            }
            if (this.form.details[i].thisPayAmount > this.form.details[i].unReceivedAmount) {
              this.$my_message(`第${i + 1}行本次付款金额大于未付款金额`, 'warning')
              return
            }

            for (let j = 0; j < this.form.details.length; j++) {
              if (i != j && this.form.details[i].invoiceRegisterId == this.form.details[j].invoiceRegisterId) {
                this.$my_message(`第${i + 1}行和第${j + 1}行重复`, 'warning')
                return
              }
            }
          }
        }
        this.form.details
        this.SaveDataAction(this.form).then((res) => {
          this.$my_message(`执行成功`, "success");
          sessionStorage.setItem("editMode", 0);
          // this.$router.push({ path: this.getMainPath(this.$route.path) });
          this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
        }).finally(() => {
          this.$store.dispatch('SetLoading',false)
        });;
      });
    },
    resetForm () {
      this.form = {
        state: 0,
        supplierName: '',
        supplierId: '',
        type: 2,
        details: [],
        totalAmount: 0,
        totalNumber: 0,
        createdTime: this.parseTime(new Date()),
        updateTime: this.parseTime(new Date()),
        createdUserName: this.userInfo.name,
        ownerDeptName: this.userInfo.deptName,
        date: this.parseTime(new Date(), "{y}-{m}-{d}"),
        orgCode :sessionStorage.getItem('orgId'),
        
      };
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
  
    },
    goBack () {
      if (this.prevRoute.path == '/') {
        this.$router.go(-1)
      }
      else {

        if (this.prevRoute.path == '/invoice-register-edit') {
          this.$router.go(-3)
        }
        else {
          this.routePushWithParams(this.prevRoute.path, this.$route.params);
        }


      }
    },

    // 明细表
    handleAddChildForm () {
      if (!this.form.supplierId) {
        this.$my_message(`需要先选择供应商`, 'warning')
        this.getProductList('')
        return;
      }
      this.showSelectDialog = true;
      this.resetDetailFormData();

    },
    handleDeleteChildForm () {
      this.form.details = this.form.details.filter(
        (i) => !this.childIds.includes(i.$index)
      );
      this.form.details.forEach((e, index) => {
        e.$index = index + 1;
      });

      this.autoTotalAmount();
    },
    handleChildSelectionChange (selection) {
      this.childMultipleSelection = selection;
      this.childIds = selection.map((item) => item.$index);
      this.childMultiple = !selection.length;
    },
    resetDetailFormData () {
      this.childForm = {
        $index: this.form.details.length + 1,
        "amount": 0,
        "unReceivedAmount": 0,
        thisPayAmount: 0,
      };
    },
    amountChange (row) {
      this.autoTotalAmount();
    },
    autoAmount () {
      this.childForm.amount =
        (this.childForm.number * this.childForm.price).toFixed(4) * 1;
      this.childForm.unBillAmount = this.childForm.amount;
    },
    autoTotalAmount () {
      let totalAmount = 0;
      this.form.details.forEach((element, index) => {
        totalAmount = totalAmount * 1 + element.thisPayAmount * 1;
      });
      this.form.totalAmount = totalAmount.toFixed(4) * 1
      this.form.totalNumber = this.form.details ? this.form.details.length : 0
    },

    // change event 
    supplierChange (val) {
      var arr = this.STATIC_Suppliers.filter(e => e.id == val)
      this.form.supplierId = arr[0].id
      this.form.supplierName = arr[0].name

      this.form.details = []

      var item = this.filterOptions.find(e => e.code == "supplierId")
      if (item) {
        item.defaultValue = this.form.supplierId
      }
      else {
        this.filterOptions.push({
          name: "供应商",
          type: 'select',
          code: 'supplierId',
          hidden: true,
          defaultValue: this.form.supplierId
        })
      }
      this.$refs.selectDialog.reset()
    },
    toInvoiceRegister (row) {
      this.routePushWithParams("/invoice-register-edit", { applyId: this.id }, { formMode: 0, id: row.invoiceRegisterId });
    },


    closeSelectDialog () {
      this.showSelectDialog = false
    },
    getSelectDialogData (data) {
      if (data) {  
        const existingIds = new Set(this.form.details.map(item => item.invoiceRegisterId));
        const duplicateItem = data.find(e => existingIds.has(e.id));
        if (duplicateItem) {
          this.$message.error(`发票重复`);
          return; 
        }
        data.map(e => {
          var detail = Object.assign({}, e)
          detail.invoiceRegisterId = e.id
          detail.invoiceRegisterNo = e.no
          detail.thisPayAmount = e.unReceivedAmount
          this.form.details.push(detail)
        })

        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });
        this.autoTotalAmount();
      }
    }
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
  overflow: auto !important;
}
/deep/.el-input-number .el-input__inner {
  text-align: left !important;
}
</style>
